import '../../../base/common/arrays.js';
import '../../../base/common/observableInternal/derived.js';
import { autorunOpts } from '../../../base/common/observableInternal/autorun.js';
import { observableFromEvent } from '../../../base/common/observableInternal/utils.js';
import '../../../base/common/cancellation.js';
function observableConfigValue(key, defaultValue, configurationService) {
    return observableFromEvent((handleChange) => configurationService.onDidChangeConfiguration(e => {
        if (e.affectsConfiguration(key)) {
            handleChange(e);
        }
    }), () => configurationService.getValue(key) ?? defaultValue);
}
function bindContextKey(key, service, computeValue) {
    const boundKey = key.bindTo(service);
    return autorunOpts({ debugName: () => `Set Context Key "${key.key}"` }, reader => {
        boundKey.set(computeValue(reader));
    });
}
export { bindContextKey, observableConfigValue };
